<template>
	<div class="footer">
		<div class="box center-width flex-box">
			<section class="section">
				<a class="title" href="about.html#/companyIntroduction" target="_blank">关于我们</a>
				<a href="about.html#/companyIntroduction" target="_blank">公司简介</a>
				<a href="about.html#/honor" target="_blank">资质荣誉</a>
				<a href="about.html#/news" target="_blank">新闻动态</a>
				<a href="about.html#/joinUs" target="_blank">加入我们</a>
				<a href="about.html#/contactUs" target="_blank">联系我们</a>
			</section>
			<section class="section">
				<a class="title" href="webTerms.html?type=1" target="_blank">网站条款</a>
				<a href="webTerms.html?type=1" target="_blank">免责声明</a>
				<a href="webTerms.html?type=2" target="_blank">隐私政策</a>
				<a href="webTerms.html?type=3" target="_blank">服务条款</a>
				<a href="webTerms.html?type=4" target="_blank">平台注册协议</a>
				<a href="webTerms.html?type=5" target="_blank">平台服务协议</a>
			</section>
			<section class="section">
				<a class="title" href="help.html?type=1" target="_blank">帮助中心</a>
				<a href="help.html?type=1" target="_blank">意见反馈</a>
				<a href="help.html?type=2" target="_blank">银行账号</a>
				<a href="help.html?type=3" target="_blank">交收仓库</a>
			</section>
			<section class="section">
				<a class="title" href="about.html?type=5" target="_blank">联系我们</a>
				<p>总台服务:0771-2266888</p>
				<p>仓库客服:0778-2482555</p>
				<p>服务时间:周一至周五(8:30-17:30)</p>
				<p class="mt20">南宁客服中心:0771-2266888</p>
				<p>宜州办事处:0778-2482555</p>
				<p>桐乡办事处:18505735660(陆敏丰)</p>
				<p>南充办事处:15078075776(罗中政)</p>
			</section>
			<section class="section">
				<div class="foot-code">
					<img src="../../assets/images/common/WeChat.jpg"/>
					<p>茧丝微信订阅号</p>
				</div>
				<div class="foot-code right">
					<img src="../../assets/images/common/App.png"/>
					<p>丝路通APP下载</p>
				</div>
				<p>丝路通APP正式上线，实时交易、融资服务、多品交付、信息获取。茧丝绸行业交易与融资业务新工具，扫一扫下载安装，办理业务快一步。</p>
			</section>
			
		</div>
	</div>
</template>

<script>
	export default {
		data() {
		  return {
      };
		},
		methods: {
		},
		components:{
		}
	}
</script>

<style lang="stylus" scoped>
.footer {
	width: 100%;
	min-width: 1220px;
	padding-bottom: 50px;
	text-align: center;
	background-color: #333333;
	.box{
		text-align: left;
  	padding: 0 10px;
		.section {
			display: inline-block;
			font-size: 14px;
			margin-top: 40px;
			vertical-align: top;
			a,p {
				display: block;
				color: #909090;
				line-height: 34px;
			}
			a:hover {
				color: #c2c2c2;;
				text-decoration: none;
			}
			.title {
				color: #fff;
				font-size: 16px;
				line-height: 56px;
				cursor: pointer;
			}
			.foot-code {
				display: inline-block;
				margin-bottom: 34px;
				img {
					width: 100px;
					height: 100px;
					margin-bottom: 10px;
				}
			}
			&:last-child {
				width: 280px;
				padding-top: 13px;
				p {
					text-align: justify; 
					line-height: 24px;
				}
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// footer.vue?7c6da3a6